import {
  type ReactNode,
  type Ref,
  type RefAttributes,
  forwardRef as reactForwardRef,
} from 'react'

export function forwardRef<T, P = object>(
  render: (props: P, ref: Ref<T>) => ReactNode
): (props: P & RefAttributes<T>) => ReactNode {
  return reactForwardRef(render as any) as any
}
